import { render, staticRenderFns } from "./CardIconItem.vue?vue&type=template&id=63f5ee2a&scoped=true"
import script from "./CardIconItem.vue?vue&type=script&lang=js"
export * from "./CardIconItem.vue?vue&type=script&lang=js"
import style0 from "./CardIconItem.vue?vue&type=style&index=0&id=63f5ee2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f5ee2a",
  null
  
)

export default component.exports